export const CLIENT_SEARCH_DEBOUNCE_MS = 250;
export const CLIENT_SEARCH_PAGE_SIZE = 20;

// Tied to the collapsed trigger's `Button size="icon"` (size-9 => 36px). If that primitive's icon
// size ever changes, update this alongside it — nothing else keeps them in sync.
export const SEARCH_FIELD_COLLAPSED_WIDTH_PX = 36;

export const SEARCH_FIELD_EXPANDED_WIDTH_PX = 320;

export const SEARCH_FIELD_EXPAND_TRANSITION = {
    type: 'spring',
    stiffness: 400,
    damping: 32,
} as const;
export const SEARCH_FIELD_REDUCED_MOTION_TRANSITION = { duration: 0 } as const;
